import { Space } from "antd";
import type { ChannelPlatformName } from "@/api/client";
import { useI18n } from "@/i18n";

/**
 * Official marketplace marks, unaltered, on a neutral light plate (Design Brief
 * §9.1). Several marks are dark, so the plate stays light.
 */
export function PlatformLogo({ platform, size = 28 }: { platform: ChannelPlatformName; size?: number }) {
  const { t } = useI18n();
  return (
    <span
      style={{
        display: "inline-grid",
        placeItems: "center",
        width: size + 12,
        height: size + 12,
        borderRadius: 10,
        border: "1px solid var(--z-line)",
        background: "white",
        flexShrink: 0,
      }}
    >
      <img src={`/logos/${platform}.svg`} alt={t(`platform.${platform}`)} style={{ maxWidth: size, maxHeight: size }} />
    </span>
  );
}

export function PlatformLabel({ platform }: { platform: ChannelPlatformName }) {
  const { t } = useI18n();
  return (
    <Space size={8}>
      <PlatformLogo platform={platform} size={18} />
      {t(`platform.${platform}`)}
    </Space>
  );
}
